import React from 'react';

export default function TermsAndConditionsPage() {
  return (
    <div className="max-w-4xl mx-auto p-8 text-gray-800 leading-7">
      <h1 className="text-3xl font-bold mb-6">Condiciones de uso</h1>

      <p className="mb-4">
        El acceso a las instalaciones, actividades y servicios de Mundolandia implica la aceptación de estas condiciones generales de uso, sin perjuicio de las instrucciones específicas de seguridad que puedan comunicarse en el propio recinto.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Menores de edad</h2>
      <ul className="list-disc pl-5 mb-4 space-y-1">
        <li>El registro y acceso de menores deberá estar vinculado a una persona adulta responsable.</li>
        <li>La persona adulta responsable deberá facilitar datos veraces y actualizados.</li>
        <li>El parque podrá requerir comprobaciones razonables de identidad o vinculación cuando resulte necesario por motivos organizativos o de seguridad.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Normas de seguridad</h2>
      <ul className="list-disc pl-5 mb-4 space-y-1">
        <li>Las personas usuarias deberán respetar en todo momento las normas del recinto y las indicaciones del personal.</li>
        <li>No se permite el uso inadecuado de instalaciones, juegos o zonas restringidas por edad o condiciones de uso.</li>
        <li>El incumplimiento de las normas podrá implicar la limitación o expulsión del recinto sin derecho a devolución cuando resulte aplicable.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Estado de salud y uso adecuado</h2>
      <p className="mb-4">
        Las personas usuarias deben valorar si su estado físico o el de los menores a su cargo es compatible con la actividad. En caso de condiciones médicas, limitaciones relevantes o necesidades especiales, se recomienda informar previamente al personal para valorar el uso adecuado de las instalaciones.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Bonos y servicios asociados</h2>
      <p className="mb-4">
        Los bonos, promociones o servicios vinculados estarán sujetos a sus condiciones particulares, incluyendo vigencia, uso disponible y reglas de canje. La información mostrada por el sistema o facilitada por el personal será la referencia operativa aplicable.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Protección de datos</h2>
      <p className="mb-4">
        Los datos personales se tratarán conforme a la normativa de protección de datos aplicable y a la política de privacidad publicada en este sitio web. La persona usuaria declara haber sido informada del tratamiento necesario para la gestión del servicio.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Responsabilidad</h2>
      <p className="mb-4">
        El titular del parque responderá conforme a la normativa aplicable de los daños imputables a una prestación defectuosa del servicio. No responderá de incidencias derivadas de un uso contrario a las normas, de omisiones relevantes de información por parte de la persona usuaria o de hechos ajenos a su control razonable.
      </p>

      <p className="mt-8 font-medium text-center text-slate-700">
        La persona usuaria declara haber leído y comprendido estas condiciones, así como las normas básicas del recinto y la información esencial sobre tratamiento de datos.
      </p>
    </div>
  );
}
